'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function CGFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-wcmrh6bqn", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-wcmrh6bqn)" }, /* @__PURE__ */ React.createElement("path", { fill: "#fa1111", d: "M32 0v24H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#07a907", d: "M0 24V0h32z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fbcd17", d: "M29.492-5.8L-1 23.576l6.052 3.012L34.64-.212z" })))
  );
}

export { CGFlag };
//# sourceMappingURL=CG.mjs.map
